module.exports = __webpack_public_path__ + "static/img/r-1-4.04ed155.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/r-1-4.png
// module id = QxKF
// module chunks = 0